import CloseIcon from '@mui/icons-material/Close';
import React from 'react';
import { t } from 'i18next';
import type { GetCardsPayload } from 'CDK_API';
import { NormalizedProject } from './SelectMultipleProjects';
import { Box, Chip, styled, Typography, IconButton } from '@mui/material';
import { GroupTypes } from 'app/pages/team/groups/utils';
import { sentryMask } from 'sentryReplayPrivacy';

interface SelectedCardProps {
  card?: GetCardsPayload;
  project?: NormalizedProject;
  groupType: GroupTypes;
  onClose?: (event: any) => void;
}

const CardContainer = styled(Box)`
  display: flex;
  border-radius: 16px;
  align-items: center;
  width: min-content;
  background: var(--Blues-Highlight-Blue, #f2f6ff);
  margin-bottom: 8px;
`;

const StyledChip = styled(Chip)`
  font-size: 14px;
`;

const StyledTypography = styled(Typography)`
  padding-left: 8px;
  padding-right: 16px;
  width: max-content;
  color: text.secondary;
  font-size: 14px;
`;

const SelectedCard: React.FC<SelectedCardProps> = ({ card, project, onClose, groupType }) => {
  const isProject = groupType === GroupTypes.ProjectGroups;

  return (
    <>
      {isProject ? (
        <Box width="100%">
          <CardContainer>
            <StyledTypography variant="caption">{`${project?.name}`}</StyledTypography>

            <IconButton onClick={onClose ? onClose : undefined}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </CardContainer>
        </Box>
      ) : (
        <Box width="100%">
          <CardContainer>
            <StyledChip label={card && `*${card.last4} `} color="primary" />
            <StyledTypography variant="caption" {...sentryMask}>{`${
              (card?.cardholder?.name || card?.name) ?? t('unassigned')
            }`}</StyledTypography>

            <IconButton onClick={onClose ? onClose : undefined}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </CardContainer>
        </Box>
      )}
    </>
  );
};

export default SelectedCard;
